import React from 'react';

import { CircularProgress, Skeleton } from '@mui/material';
import { Box } from '@mui/system';

export enum ILoader {
  SPINNER = 'Spinner',
  SKELETON = 'Skeleton',
}

interface LoadingLayoutProps {
  style?: any;
  loading: boolean;
  children: React.ReactChild;
  type?: ILoader;
}

export default function LoadingLayout({
  style,
  loading,
  children,
  type = ILoader.SPINNER,
}: LoadingLayoutProps) {
  return (
    <Box>
      {loading ? (
        <Box sx={[styles.loader, style]}>
          {type === ILoader.SKELETON && <Skeleton />}
          {type === ILoader.SPINNER && <CircularProgress />}
        </Box>
      ) : (
        <Box>{children}</Box>
      )}
    </Box>
  );
}

const styles = {
  loader: { my: 6, textAlign: 'center' },
};
